import React, { ReactNode } from 'react';
import { mcWithoutContent } from '@mc/react-ui-icons';
import classNames from 'classnames';
import { Icon } from '../icon/Icon';
import * as Classes from '../common/classes';

type Props = {
  /**
   * Registrační značka, např. "5P74455".
   */
  rz: string;
  /**
   * Tovární značka, např. "Škoda".
   */
  tovarniZnacka?: string;
  /**
   * MPZ kód, např. "CZ". Pokud není zadán, zobrazí se ikona že není dostupný (přeškrtnutý kruh).
   */
  kodMpz?: string;
  /**
   * Zmenšený RZ.
   */
  small?: boolean;
  /**
   * Extra sekce např. pro tlačítka.
   */
  extra?: ReactNode;
  noBottomRadius?: boolean;
  className?: string;
};

export const Rz: React.FC<Props> = ({
  rz,
  tovarniZnacka,
  kodMpz,
  extra,
  noBottomRadius,
  small,
  className,
}) => {
  return (
    <div
      className={classNames(
        Classes.RZ_WRAPPER,
        {
          [Classes.RZ_WRAPPER_NO_RADIUS]: noBottomRadius,
          [Classes.RZ_WRAPPER_SMALL]: small,
        },
        className
      )}
    >
      <div className={Classes.RZ_WRAPPER_CONTENT}>
        <div
          className={classNames(Classes.RZ_WRAPPER_MPZ, {
            [Classes.RZ_WRAPPER_NO_MPZ]: !kodMpz,
          })}
        >
          {kodMpz ? kodMpz : <Icon fixedWidth icon={mcWithoutContent} />}
        </div>
        <div className={Classes.RZ_WRAPPER_RZ}>{rz}</div>
        {extra && <div className={Classes.RZ_WRAPPER_EXTRA}>{extra}</div>}
      </div>
      {tovarniZnacka && (
        <div className={Classes.RZ_WRAPPER_ZNACKA}>{tovarniZnacka}</div>
      )}
    </div>
  );
};
